module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc1-02-b621983663f1e91bddf84f198d6c5992.png";